module.exports = __webpack_public_path__ + "img/signIcon.ca13971c.svg";